import AudienceName from './AudienceName.Container';

export default AudienceName;
